import { Component, HostListener, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { Layer } from 'src/app/menu/view-menu/layer';
import { MapService } from 'src/app/services/map.service';
import { PointsService } from 'src/app/services/points.service';
import { MapPreviewComponent } from '../map-preview/map-preview.component';
@Component({
  selector: 'app-print-map',
  templateUrl: './print-map.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class PrintMapComponent implements OnInit {


  @Input()
  type: string;

  titleMargin = 0.05;
  smallMargin = 0.005;
  legendWidth = 0.2;
  legendHeight = 0.5;

  legendColorWidth = 0.025;
  legendColorHeight = 0.01; // height of each legend
  spaceBetweenLegends = 0.025;
  yLegendMargin = 0.025 // space between legends and 'Legend:' string
  legendTitle = 0.03 // height of 'Legend:'
  xLegendMargin = 0.015

  fileName :string= "file";
  fileFormat : string=".png";

  title:string;
  information: string;
  legendPosition: string = "upperLeft";

  drawFullLegend: boolean = true;
  drawCalculationIdLegend: boolean = true;

  mapCanvas : HTMLCanvasElement;
  calculationName: string;


  legendColorMap :  Map<string, Map<string, string>> = new Map([
    ['Redundancy', new Map([
      ['No Coverage','rgba(117, 115, 107,0.5)'],
      ['No Redundancy','rgba(246, 112, 104,0.5)'],
      ['Limited Redundancy','rgba(245, 244, 109,0.5)'],
      ['Full Redundancy','rgba(117, 244, 107,0.5)'],
      ['High Redundancy','rgba(121, 120, 235,0.5)'],
    ])],
    ['Available Pairs',  new Map([
      ['No Coverage','rgba(117, 115, 107,0.5)'],
      ['No Redundancy','rgba(246, 112, 104,0.5)'],
      ['Limited Redundancy','rgba(245, 244, 109,0.5)'],
      ['Full Redundancy','rgba(117, 244, 107,0.5)'],
      ['High Redundancy','rgba(121, 120, 235,0.5)'],
    ])],
    ['NSE', new Map([
      ['0-0.2','rgba(0, 255, 0,0.5)'],
      ['0.2-0.4','rgba(80, 255, 80,0.5)'] ,
      ['0.4-0.6','rgba(130, 255, 130,0.5)'],
      ['0.6-0.866','rgba(200, 255, 200,0.5)' ],
      ['0.866-1','rgba(255, 200, 200,0.5)'],
      ['1-2','rgba(255, 130, 130,0.5)'],
      ['2-3','rgba(255, 80, 80,0.5)'],
      ['>3','rgba(255, 0, 0,0.5)' ],
      ['VOID','rgba(117, 115, 107,0.5)'],
    ])],
    ['Subtended Angles', new Map([
      ['0-30','rgba(117, 115, 107,0.5)'],
      ['30-40','rgba(245, 214, 206,0.5)'],
      ['40-50','rgba(246, 112, 104,0.5)'],
      ['50-60','rgba(245, 244, 109,0.5)'],
      ['60-70', 'rgba(121, 120, 235,0.5)'],
      ['70-80', 'rgba(217, 103, 218,0.5)'],
      ['80-90', 'rgba(117, 244, 107,0.5)']
    ])],
    ['Signal Delay', new Map([
      ['No Coverage','rgba(117, 115, 107,0.5)'],
      ['No Redundancy','rgba(246, 112, 104,0.5)'],
      ['Limited Redundancy','rgba(245, 244, 109,0.5)'],
      ['Full Redundancy','rgba(117, 244, 107,0.5)'],
      ['High Redundancy','rgba(121, 120, 235,0.5)'],
    ])]
  ]);
  constructor(private bsModalRef : BsModalRef,
    private popupService: BsModalService,
    private mapService: MapService,
    public pointsService: PointsService,
    public globalSelectionService: GlobalSelectionControlService,
  ) {
    this.mapCanvas = document.createElement('canvas');
   }
  ngOnInit(): void {
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.cancel(false); // escape key already hides the modal
  }

  cancel(hideModal: boolean = true){
    hideModal? this.bsModalRef.hide(): false;
    this.calculationName="";
  }

  writeText(mapContext: CanvasRenderingContext2D,text, x:number,y,height:number,bold:boolean){
    mapContext.globalAlpha = 1;
    mapContext.fillStyle = 'black';
    mapContext.font = `${bold ? 'bold': ''} ${height}px serif`;
    mapContext.fillText(text,x,y);
  }
  drawRectangle(mapContext: CanvasRenderingContext2D, fillColor:string,point:number[],width,height,alpha){
    mapContext.fillStyle = fillColor;
    mapContext.strokeStyle = "black";
    mapContext.globalAlpha = alpha;
    mapContext.fillRect(point[0],point[1],width,height);
    mapContext.strokeRect(point[0],point[1],width,height);
  }
  drawLine(mapContext: CanvasRenderingContext2D,beginPoint:number[],endPoint:number[]){
    mapContext.strokeStyle = 'black'
    mapContext.beginPath();
    mapContext.moveTo(beginPoint[0],beginPoint[1]);
    mapContext.lineTo(endPoint[0],endPoint[1]);
    mapContext.stroke();
  }
  getLegendLocation(legendPosition,titleActive:boolean, informationActive: boolean,numLegends:number){

    let yPosition:number;
    let upperMarginCount = titleActive? 1 : 0;
    let footerMarginCount = informationActive? 2: 1;
    if(legendPosition.startsWith('lower')){
      let legendBoxHeight = numLegends*(this.legendColorHeight + this.spaceBetweenLegends) + this.legendTitle + this.yLegendMargin
      if(legendBoxHeight > (1 - ((footerMarginCount + upperMarginCount)*this.titleMargin + 2*this.smallMargin))){
        legendBoxHeight = (1 - ((footerMarginCount + upperMarginCount)*this.titleMargin + 2*this.smallMargin));
      }
      else if(legendBoxHeight < this.legendHeight){
        legendBoxHeight = this.legendHeight;
      }
      yPosition = (1 - footerMarginCount*this.titleMargin - this.smallMargin - legendBoxHeight);
    }
    let result: number[] = null
    switch (legendPosition){
      case "upperLeft" : result = [this.smallMargin,this.titleMargin*upperMarginCount + this.smallMargin];break;
      case "upperRight":  result =  [1 - this.legendWidth- this.smallMargin, this.titleMargin*upperMarginCount + this.smallMargin];break;
      case "lowerLeft" : result =  [this.smallMargin, yPosition];break;
      case "lowerRight" : result =  [1 - this.legendWidth - this.smallMargin,yPosition];break;
    }
    return [this.mapCanvas.width*result[0], this.mapCanvas.height*result[1]];
  }

  drawLegends(mapContext: CanvasRenderingContext2D,legends: Legend[], legendBoxCoords: number[]){
    //Legend title
    let legendTitleHeight = this.legendTitle*this.mapCanvas.height;
    this.writeText(mapContext,"Legend:",
    legendBoxCoords[0] + this.mapCanvas.width*this.legendWidth/3, legendBoxCoords[1] + legendTitleHeight,legendTitleHeight,true)


    let yLegendLocation = this.mapCanvas.height*this.yLegendMargin + legendBoxCoords[1] + legendTitleHeight;
    let xLegendLocation = this.mapCanvas.width*this.xLegendMargin + legendBoxCoords[0];

    let xLegendTextLocation = xLegendLocation + this.mapCanvas.width*(this.legendColorWidth + this.xLegendMargin);
    let yLegendTextLocation = yLegendLocation + this.mapCanvas.height*this.legendColorHeight

    legends.forEach((legend:Legend) => {
      this.drawRectangle(mapContext,legend.color, [xLegendLocation,yLegendLocation],
      this.mapCanvas.width*this.legendColorWidth,
      this.mapCanvas.height*this.legendColorHeight,1);

      this.writeText(mapContext, legend.label, xLegendTextLocation, yLegendTextLocation,3*this.legendColorHeight*this.mapCanvas.height,true);
      yLegendLocation += this.mapCanvas.height*(this.legendColorHeight + this.spaceBetweenLegends);
      yLegendTextLocation += this.mapCanvas.height*(this.legendColorHeight + this.spaceBetweenLegends);
    })
    let legendBoxHeight = yLegendTextLocation - legendBoxCoords[1] > this.legendHeight*this.mapCanvas.height
                  ? yLegendTextLocation - legendBoxCoords[1] : this.legendHeight*this.mapCanvas.height;

    this.drawRectangle(mapContext,'grey',legendBoxCoords,this.legendWidth*this.mapCanvas.width ,legendBoxHeight,0.2);



  }
  isLayerOnScreen(layer:Layer, map){
    var layerIsOnScreen: boolean = false;
    if(!layer.visible){
      return;
    }
    var source  = layer.olLayer.getSource();
    source.forEachFeatureIntersectingExtent(map.getView().calculateExtent(map.getSize()), function(feature){
      layerIsOnScreen = true;
    })
    return layerIsOnScreen
  }
  drawLayersLegends(mapContext:CanvasRenderingContext2D,map,titleActive: boolean,informationActive: boolean){
    mapContext.setTransform(1, 0, 0, 1, 0, 0);


    var calculationResultsLayers = this.pointsService.getCalculationsLayer().childLayers;
    var legends: Legend[] = [];
    for(let layer of calculationResultsLayers){
      if(layer.type == 'Coverage' || layer.type == 'Cumulative Coverage'){
        if(this.isLayerOnScreen(layer.layers[0],map)){
          if(layer.type == 'Coverage')
          layer.elevation_info.forEach((color,elevation) => legends.push(new Legend(elevation,color)))
          else{
            let i = 1;
            for(let color of layer.cumulative_coverage_colors){
              legends.push(new Legend(i.toString(),color));
              i++;
            }
          }
          this.calculationName = layer.name
        }
      }
      else if(layer.type == 'PERFORMANCE' || layer.type == 'PROCEDURE_ANALYSIS'){
        var topLeveLayerIsOnScreen: boolean = false;
        for (const subLayer of layer.layers) {
          if(this.isLayerOnScreen(subLayer,map)){
            var layerLegends = this.legendColorMap.get(subLayer.name);
            if (layerLegends) {
              layerLegends.forEach((color,label) => {
                legends.push(new Legend(label,color));
              });
            }
            topLeveLayerIsOnScreen = true;
          }
        }
        if(topLeveLayerIsOnScreen){
          this.calculationName = layer.name;
        }
      }
      else if(layer.type == 'TerrainAltitudeCut'){
        if(this.isLayerOnScreen(layer.layers[0],map))
          legends.push(new Legend('Above '+ layer.layers[0].name.split(" ")[3],'rgb(255,0,0)'))
      }
      else if(layer.type == 'NavaidSitingTool'){
        if(this.isLayerOnScreen(layer.layers[0],map)){
          let sublayer: any = layer.layers[0];
          legends.push(...cloneDeep(sublayer.subtitles));
        }
      }
      else if(layer.type == 'Overlap'){
        layer.layers.forEach((sublayer: any)=>{
          if(this.isLayerOnScreen(sublayer,map)){
            const overlapColors = layer.overlap_frequency_colors.get(sublayer.layerFreq);
            if (overlapColors) {
              overlapColors.forEach((color:any,index:number)=>{
                legends.push(new Legend(JSON.stringify(index+1),color));
              });
            }
          }
        })

      }
    }

    let legendCoords: number[] = this.getLegendLocation(this.legendPosition,titleActive,informationActive, legends.length);
    this.drawLegends(mapContext, legends,legendCoords);

  }
  drawTitle(mapContext,titleMargin,smallMargin){

    mapContext.setTransform(1, 0, 0, 1, 0, 0);
    this.drawLine(mapContext,[0,titleMargin],[this.mapCanvas.width,titleMargin]);
    this.drawRectangle(mapContext,'white',[0,0],this.mapCanvas.width,titleMargin,1);
    this.writeText(mapContext,this.title,2*smallMargin,titleMargin - smallMargin, titleMargin - 2*smallMargin,false);
  }
  drawFooter(mapContext,footerMargin,smallMargin){
    mapContext.setTransform(1, 0, 0, 1, 0, 0);
    this.drawLine(mapContext,[0,this.mapCanvas.height-footerMargin],[this.mapCanvas.width,this.mapCanvas.height-footerMargin]);
    this.drawRectangle(mapContext,'white',[0,this.mapCanvas.height-footerMargin],this.mapCanvas.width,footerMargin,1);
    this.writeText(mapContext,this.information,0,this.mapCanvas.height - smallMargin, footerMargin - smallMargin,false);
  }
  layerOnScreen(layer,map):boolean{
    var source  = layer.olLayer.getSource();
    let layerIsOnScreen = false;
    source.forEachFeatureIntersectingExtent(map.getView().calculateExtent(map.getSize()), function(feature){
      layerIsOnScreen = true;
    })
    return layerIsOnScreen;
  }
  getTextOfLastVisibleLayer(map){
    if(this.calculationName != null && this.calculationName != "" ){
      return this.calculationName;
    }
    let procedureLayers = this.globalSelectionService.proceduresLayersMenu.filter((layer)=> layer.visible && this.layerOnScreen(layer,map))
    if(procedureLayers.length != 0){
      return "Procedures/"+procedureLayers[procedureLayers.length-1].name;
    }
    let navaidLayers =  this.globalSelectionService.navaidsLayers.childLayers[0].layers.filter((layer)=> layer.visible);
    if(navaidLayers.length != 0){
      return  "Navaids/Reference Navaids/"+navaidLayers[navaidLayers.length-1].name
    }
  }
  drawLayerFooter(mapContext, map, yLocation, footerMargin, smallMargin){


   mapContext.setTransform(1, 0, 0, 1, 0, 0);
    this.drawLine(mapContext,[0,yLocation],[this.mapCanvas.width,yLocation]);
    this.drawRectangle(mapContext,'white',[0,yLocation],this.mapCanvas.width,footerMargin,1);
    this.writeText(mapContext,this.getTextOfLastVisibleLayer(map),0,yLocation + footerMargin - smallMargin, footerMargin - smallMargin,false);
  }

  exportFile(dataURL: string){
    const map = this.mapService.getMap('map');
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = dataURL;
    a.download = this.fileName + this.fileFormat;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    map.renderSync();

  }

  print(dataURL: string){

    let windowContent = '<!DOCTYPE html>';
    windowContent += '<html>';
    windowContent += '<head><title>Print canvas</title></head>';
    windowContent += '<body>';
    windowContent += '<img src="' + dataURL + '" height="'+300+ '" width="'+ 300*this.mapCanvas.width/this.mapCanvas.height+'">';
    windowContent += '</body>';
    windowContent += '</html>';

    const printWin = window.open('', '', 'width=' + this.mapCanvas.width + ',height=' + this.mapCanvas.height);
    printWin.document.open();
    printWin.document.write(windowContent);

    printWin.document.addEventListener('load', function() {
        printWin.focus();
        printWin.print();
        printWin.document.close();
        printWin.close();
    }, true);
  }


  getMapURL(): string {
    this.renderMapToCanvas();
    return this.mapCanvas.toDataURL('image/png');
  }
  private renderMapToCanvas(): void {
    const map = this.mapService.getMap('map');
      const size = map.getSize();
      this.mapCanvas.width = size[0];
      this.mapCanvas.height =  size[1];
      let fieldHeight = this.titleMargin*this.mapCanvas.height;
      let titleActive: boolean = this.title != null && this.title != "";
      let titleMargin =titleActive ? fieldHeight : 0;
      let informationActive = this.information != null && this.information != "";
      let smallMargin = this.smallMargin*this.mapCanvas.height;
      const mapContext = this.mapCanvas.getContext('2d');
      this.drawRectangle(mapContext,"white",[0,0], this.mapCanvas.width,this.mapCanvas.height,1)
      Array.prototype.forEach.call(
        map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
        function (canvas) {
          if (canvas.width > 0) {
            let matrix;
            const transform = canvas.style.transform;
            if (transform) {
              // Get the transform parameters from the style's transform matrix
              matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            } else {
              matrix = [
                parseFloat(canvas.style.width) / canvas.width,
                0,
                0,
                parseFloat(canvas.style.height) / canvas.height,
                0,
                0,
              ];
            }
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
              );
              canvas.setAttribute("crossOrigin", "anonymous");
              mapContext.drawImage(canvas, 0, titleMargin);
            }
          }
          );
          if(this.drawFullLegend){
            let yLocation = informationActive? this.mapCanvas.height-2*fieldHeight : this.mapCanvas.height-fieldHeight
            this.drawLayersLegends(mapContext,map,titleActive,informationActive);
            this.drawLayerFooter(mapContext,map,yLocation,fieldHeight,smallMargin)
          }
          if(this.title != null && this.title != ""){
            this.drawTitle(mapContext,fieldHeight,smallMargin)
          }
          if(informationActive){
            this.drawFooter(mapContext,fieldHeight,smallMargin)
          }
}

  private getMapBlobUrl(): Promise<string> {
    this.renderMapToCanvas();
    return new Promise((resolve, reject) => {
      this.mapCanvas.toBlob((blob) => {
        if (!blob) return reject(new Error('Failed to create blob from canvas'));
        resolve(URL.createObjectURL(blob));
      }, 'image/png');
    });
}

  private printImageUrl(imageUrl: string): boolean {
    const w = window.open('', '_blank', `width=${this.mapCanvas.width},height=${this.mapCanvas.height}`);
    if (!w) return false;
    w.document.open();
    w.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Print canvas</title>
          <style>
            html, body { margin:0; padding:0; }
            img { width: 100%; height: auto; display:block; }
          </style>
        </head>
        <body>
          <img id="img" src="${imageUrl}" />
          <script>
            const img = document.getElementById('img');
            img.onload = () => { window.focus(); window.print(); };
            img.onerror = () => { window.focus(); window.print(); };
            window.onafterprint = () => {
              try { URL.revokeObjectURL("${imageUrl}"); } catch(e) {}
              window.close();
            };
          </script>
        </body>
      </html>
    `);
    w.document.close();
    return true;
}

  async ok() {
    if (this.type === "export") {
      const mapURL = this.getMapURL(); // dataURL ok para download
      this.exportFile(mapURL);
    } else {
      const blobUrl = await this.getMapBlobUrl();
      this.printImageUrl(blobUrl);

    }
    this.bsModalRef.hide();
    this.calculationName = "";
  }
  preview(){
    const bsRef:BsModalRef  = this.popupService.show(MapPreviewComponent);
    bsRef.content.imageData = this.getMapURL();
    this.mapCanvas.toBlob((blob:Blob) => bsRef.content.pngImageBlob = blob)
    bsRef.content.ratio = this.mapCanvas.width/this.mapCanvas.height
  }
}

export class Legend{
  label: string;
  color: string;
  constructor(label:string,
    color: string
    ){
      this.label = label;
      this.color = color;
    }
}



